/**
 * Social Tool (beta)
 *
 * Monitoring + AI triage for the social media assistant: raw view of
 * polled items and their Haiku verdicts, source management, and
 * pause/throttle controls. Later phases add drafting and the review queue.
 */

import { FaSatelliteDish } from 'react-icons/fa';
import { BaseTool } from '../BaseTool';

export class SocialTool extends BaseTool {
  constructor() {
    super();

    this.id          = 'social';
    this.name        = 'Social (beta)';
    this.description = 'News & social monitoring with AI triage, suggestion queue, and press-visibility roster';
    this.icon        = FaSatelliteDish;
    this.color       = '#0e7c66'; // teal — matches the project proposal accent

    this.path = '/dashboard/tools/social';

    this.collections = ['social_items', 'social_sources', 'social_settings', 'social_counters', 'social_suggestions', 'social_press_targets'];

    this.requiresAdmin = false;

    this.summaryConfig = {
      enabled: false,
    };
  }

  async getSummaryData() {
    return { success: true, data: {}, lastUpdated: new Date() };
  }
}
